import { Icon, IconType, Text } from '@gimlite/ui-v2';
import classNames from 'classnames';
import dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import './module.component.scss';

dayjs.extend(duration as any);

export declare namespace ProductDigitaType {
  type Props = {
    className?: string;
    data: {
      label: string;
      description: string;
      title: string;
      color: string;
      url: string;
      logo: string;
    };
    config: {
      isActive: boolean;
    };
  };
}

export const Module = ({
  className,
  data,
  config: { isActive },
}: ProductDigitaType.Props) => {
  const { label, title, description, color, url, logo } = data;
  return (
    <div
      style={{ backgroundColor: color }}
      onClick={() => {
        if (isActive) window.location.replace(url);
      }}
      className={`module ${
        isActive ? 'module--active' : 'module--inactive'
      } ${className}`}
    >
      <div className="module__present">
        <div className="module__present__intro">
          <Text variant="label" color="black_90">
            {label.toUpperCase()}
          </Text>
          <Icon variant="ellipsis" color="black_90"></Icon>
        </div>
        <Text variant="title-1" color="black_90">
          {title}
        </Text>
        <Text variant="body" color="black_90">
          {description}
        </Text>
      </div>

      <div className="module__action">
        <Icon
          variant={logo as IconType.Props['variant']}
          color="black_90"
          size="xxl"
        ></Icon>
        {isActive && (
          <div
            className={classNames('module__action__button', {
              'module__action__button--disabled': !isActive,
            })}
          >
            <Icon
              className={'module__action__button__icon'}
              variant="arrow_right"
              color="white_100"
            ></Icon>
          </div>
        )}
      </div>
    </div>
  );
};
